import React from "react";
import { StyledDivider } from "./Divider.styled";

type DividerProps = {
  vertical?: boolean;
  margin?: number;
  color?: string;
};

export const Divider = ({ vertical, margin = 20, color }: DividerProps) => {
  return (
    <StyledDivider
      $vertical={vertical ?? false}
      $margin={margin}
      $color={color}
    />
  );
};
